import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M19 4H5c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H5V6h14v12z"
}), 'Crop32TwoTone');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/Crop32TwoTone.js
// module id = 2993
// module chunks = 2